module.exports = __webpack_public_path__ + "static/media/bar.1cc03970.svg";